// Date to format YYYY-MM-DD. If you need the date to be in YYYY-M-D format, please, use ./date.ts
const formatDateEnriched = (date: Date) => {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString();
  const day = date.getDate().toString();

  return 'y-m-d'.replace('y', year)
    .replace('m', month.length === 1 ? `0${month}` : month)
    .replace('d', day.length === 1 ? `0${day}` : day);
};

export { formatDateEnriched };
